import { z } from 'zod';
import type { TFunction } from 'i18next';

/** Validates a checklist name on create/rename. */
export const createChecklistNameSchema = (t: TFunction) =>
  z
    .string()
    .trim()
    .min(1, t('checklists:errors.nameRequired'))
    .max(200, t('checklists:errors.nameMax', { max: 200 }));

/** Validates a checklist item title on add/edit. */
export const createChecklistItemTitleSchema = (t: TFunction) =>
  z
    .string()
    .trim()
    .min(1, t('checklists:errors.itemTitleRequired'))
    .max(500, t('checklists:errors.itemTitleMax', { max: 500 }));
